const About = () => {
  return <>About</>;
};

export default About;
